import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'sonner';
import Header from './components/Header';
import Home from './pages/Home';
import './styles/global.css';
import './styles/header.css';
import './styles/cupcheck.css';
import './styles/hero.css';
import './styles/about.css';
import './styles/services.css';
import './styles/testimonials.css';
import './styles/contact.css';
import './styles/footer.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
